import { AbstractControl, NgControl } from '@angular/forms';
import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';

// enums
import { zerosAtFirst } from 'src/app/core/enums/regx/regx-match';

@Directive({
  selector: '[removeZerosAtFirst]'
})
export class RemoveZerosAtFirstDirective implements OnInit {

  abstractControl: AbstractControl | null

  @HostListener('input') checkText() {

    const { value } = this.el.nativeElement;

    this.abstractControl?.setValue((value || this.abstractControl.value)?.toString()?.replace(new RegExp(zerosAtFirst, 'gi'), ''))

  }

  constructor(
    private control: NgControl,
    private el: ElementRef<HTMLInputElement | HTMLTextAreaElement>
  ) { }

  ngOnInit(): void {
    this.el.nativeElement.setAttribute('dir', 'auto')

    if (this.control) this.abstractControl = this.control.control
  }

}
